<template>
    <div class="tb-box">
      <IMTable
        v-bind="$props"
        :tableTitle="title"
        :tableSubTitle="subTitle"
        :table-head.sync="tableHead"
        :table-data.sync="tableData"
        @onRowClick="onRowClick"
      />
        <p class="total" v-if="typeof total !== 'string'">
            <span class="name">总计扣除：</span>
            <span>{{total}}</span>
        </p>
    </div>
</template>

<script>
export default {
  name: 'table-box',
  props: {
    title: String,
    subTitle: String,
    tableHead: Array,
    tableData: Array,
    isOrder: Boolean,
    isPage: Boolean,
    total: [String,Number]
  },
  methods: {
    onRowClick (row) {
      this.$emit('onRowClick', row)
    }
  }
}
</script>

<style lang="scss" scoped>
.tb-box /deep/ .container-table{
    padding: 30px 20px 30px;
    width: calc(100% - 40px);
}
.total{
    width: 90%;
    text-align: left;
    margin-left: 20px;
    position: relative;
    top: -6px;

    .name{margin-right: 10px;}
}
</style>
